module.exports = __webpack_public_path__ + "media/images/icons/twotone/setting-af0b51d007d508384c3a8be60a49298f.svg";